// Contact fire damage (MB.3) — standing on a hot block hurts, and campfires also
// set you alight. PURE (ENG-1). The host reads this in its survival tick and
// applies the damage on a hurt-cooldown cadence (not literally every tick).

/** Damage per application standing on a lit campfire (Java 1). */
export const CAMPFIRE_BURN = 1;
/** A soul campfire burns hotter (Java 2). */
export const SOUL_CAMPFIRE_BURN = 2;
/** Magma-block contact damage (Java 1; avoided by sneaking). */
export const MAGMA_BURN = 1;
/** How often contact damage may land (Java hurt cooldown, 10 gt = 0.5 s). */
export const BURN_INTERVAL = 10;
/** Fire ticks a campfire ignites you for while you stand in its flames. */
export const CAMPFIRE_FIRE_TICKS = 20;

/** Damage per application for standing on `block`; 0 if it isn't hot. Sneaking
 *  avoids magma-block damage (Java), but never the open flame of a campfire. */
export function contactBurnDamage(block: string | undefined, sneaking: boolean): number {
  switch (block) {
    case 'campfire': return CAMPFIRE_BURN;
    case 'soul_campfire': return SOUL_CAMPFIRE_BURN;
    case 'magma_block': return sneaking ? 0 : MAGMA_BURN;
    default: return 0;
  }
}

/** Whether contact with `block` also sets the entity on fire (campfires do; a
 *  magma block scorches but doesn't ignite). */
export function ignitesOnContact(block: string | undefined): boolean {
  return block === 'campfire' || block === 'soul_campfire';
}
